import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import InvisibleClimate from "./sections/InvisibleClimate";
import InvisibleComfort from "./sections/InvisibleComfort";
import Applications from "./sections/Applications";
import Compliance from "./sections/Compliance";
import Testimonials from "./sections/Testimonials";
import Climate from "./sections/Climate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <InvisibleClimate />
      <InvisibleComfort />
      <Applications />
      <Compliance />
      <Testimonials />
      <Climate />
      <Footer />
    </div>;
}